import { sanitize } from '../../tools/serialisation/sanitize';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { toStackTraceString } from '../../tools/stackTrace/handlingStack';
import { isIndexableObject } from '../../tools/utils/typeUtils';
export const NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeErrorBase({ originalError, stackTrace, source, useFallbackStack = true, nonErrorPrefix, }) {
    const isErrorInstance = isError(originalError);
    if (!stackTrace && isErrorInstance) {
        stackTrace = computeStackTrace(originalError);
    }
    return {
        source,
        type: stackTrace ? stackTrace.name : undefined,
        message: computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
        stack: stackTrace ? toStackTraceString(stackTrace) : useFallbackStack ? NO_ERROR_STACK_PRESENT_MESSAGE : undefined,
    };
}
export function computeRawError({ stackTrace, originalError, handlingStack, componentStack, startClocks, nonErrorPrefix, useFallbackStack = true, source, handling, }) {
    const errorBase = computeErrorBase({ originalError, stackTrace, source, useFallbackStack, nonErrorPrefix });
    return {
        startClocks,
        handling,
        handlingStack,
        componentStack,
        originalError,
        ...errorBase,
        causes: isError(originalError) ? flattenErrorCauses(originalError, source) : undefined,
        fingerprint: tryToGetFingerprint(originalError),
        context: tryToGetErrorContext(originalError),
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return stackTrace?.message && stackTrace?.name
        ? stackTrace.message
        : !isErrorInstance
            ? nonErrorPrefix
                ? `${nonErrorPrefix} ${jsonStringify(sanitize(originalError))}`
                : jsonStringify(sanitize(originalError))
            : 'Empty message';
}
export function tryToGetFingerprint(originalError) {
    return isError(originalError) && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
export function tryToGetErrorContext(originalError) {
    if (isIndexableObject(originalError)) {
        return originalError.dd_context;
    }
}
export function getFileFromStackTraceString(stack) {
    return /@ (.+)/.exec(stack)?.[1];
}
export function isError(error) {
    return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
}
export function flattenErrorCauses(error, parentSource) {
    const causes = [];
    let currentCause = error.cause;
    while (currentCause !== undefined && currentCause !== null && causes.length < 10) {
        const causeBase = computeErrorBase({
            originalError: currentCause,
            source: parentSource,
            useFallbackStack: false,
        });
        causes.push(causeBase);
        currentCause = isError(currentCause) ? currentCause.cause : undefined;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map